import { RecursiveObject } from '@chakra-ui/react';

export const lineHeights: RecursiveObject = {
  xxs: '0.625rem',
};
